export default __webpack_public_path__ + "static/media/gallery3.3c9db805.jpg";